export default {
  importModalContainer: { width: 420, display: 'flex', flexDirection: 'column', gap: 2, pt: 1 },
  dropzone: {
    mt: 2,
    p: 3,
    textAlign: 'center',
    border: '1px dashed #d4d7de',
    borderRadius: 2,
    backgroundColor: '#fafafb',
    color: '#8e96a3',
    cursor: 'pointer',
  },
  dropzoneDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  dropzoneIcon: {
    fontSize: 34,
    color: '#aab0bb',
  },
  dropzoneText: {
    color: '#6f7785',
    maxWidth: 420,
    mx: 'auto',
    mb: 1.5,
  },
  browseButton: {
    border: 0,
    p: 0,
    m: 0,
    bgcolor: 'transparent',
    textDecoration: 'underline',
    color: '#1A5787',
    cursor: 'pointer',
    font: 'inherit',
  },
  browseButtonDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  dropzoneMeta: {
    color: '#95a0af',
    fontSize: 14,
  },
  selectedFile: {
    mt: 1,
    px: 1.5,
    py: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    borderRadius: 2,
    border: '1px solid #e2e5ea',
    backgroundColor: '#f7f8fa',
    maxWidth: '100%',
  },
  selectedFileIcon: {
    fontSize: 20,
    color: '#8e96a3',
  },
  selectedFileName: {
    flex: 1,
    fontSize: 14,
    color: '#2f3542',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  errorsContainer: {
    mt: 2,
    p: 2,
    borderRadius: 2,
    border: '1px solid #f5c2c7',
    backgroundColor: '#fef2f2',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  errorsText: {
    color: '#7f1530',
    fontWeight: 600,
    fontSize: '0.95rem',
  },
  errorsSubtext: {
    color: '#8f1f3a',
    fontSize: '0.85rem',
  },
  downloadButton: {
    px: 2,
    py: 1,
    mt: 2,
    borderRadius: 1,
    backgroundColor: '#7f1530',
    textTransform: 'none',
    color: '#fff',
    fontWeight: 500,
    fontSize: '0.85rem',
    whiteSpace: 'nowrap',

    '&:hover': {
      backgroundColor: '#6f1027',
    },
  },
};
